import { render, staticRenderFns } from "./UsersFormcreate.vue?vue&type=template&id=61b10510&"
import script from "./UsersFormcreate.vue?vue&type=script&lang=js&"
export * from "./UsersFormcreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports